import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Layout from "../components/layouts/Layout";
import { newsData } from "../data/newsData";

const NewsIRPage = () => {
  const { id } = useParams();
  const [filterCategory, setFilterCategory] = useState('all');

  const categories = ['all', '認定', '技術', '事業展開', 'メディア', 'アップデート', 'お知らせ', '製品情報', 'イベント', '企業情報', '交流'];

  const filteredArticles = newsData.filter(article => {
    return filterCategory === 'all' || article.category === filterCategory;
  });

  // 個別記事詳細表示
  if (id) {
    const article = newsData.find(a => a.id === parseInt(id));
    if (!article) return <div>記事が見つかりません</div>;

    return (
      <Layout 
        title={article.title} 
        subtitle={`${article.date} - ${article.category}`}
      >
        <section style={{ padding: '80px 0', backgroundColor: '#1e293b' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-8">
                <article className="premium-card" style={{ 
                  padding: '40px',
                  background: 'rgba(30, 41, 59, 0.8)',
                  border: '1px solid rgba(59, 130, 246, 0.2)',
                  borderRadius: '12px'
                }}>
                  <div style={{ marginBottom: '30px' }}>
                    <div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
                      <span style={{ 
                        background: '#1e40af', 
                        color: 'white', 
                        padding: '4px 12px', 
                        borderRadius: '20px',
                        fontSize: '12px'
                      }}>
                        {article.category}
                      </span>
                      <span style={{ color: '#94a3b8', fontSize: '14px' }}>
                        {article.date}
                      </span>
                    </div>
                    <h1 style={{ color: '#f8fafc', marginBottom: '10px', fontSize: '28px' }}>
                      {article.title}
                    </h1>
                    <p style={{ color: '#cbd5e1', fontSize: '16px' }}>{article.summary}</p>
                  </div>

                  <div style={{ 
                    color: '#cbd5e1', 
                    lineHeight: '1.8',
                    fontSize: '16px',
                    marginBottom: '30px'
                  }}>
                    {article.content.split('\n').map((paragraph, index) => (
                      <p key={index} style={{ marginBottom: '20px' }}>
                        {paragraph}
                      </p>
                    ))}
                  </div>

                  {(article.url || article.urls) && (
                    <div style={{ marginBottom: '30px' }}>
                      <h3 style={{ color: '#f8fafc', marginBottom: '15px' }}>関連リンク</h3>
                      {article.url && (
                        <a 
                          href={article.url} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          style={{ 
                            color: '#3b82f6', 
                            textDecoration: 'none',
                            display: 'block',
                            marginBottom: '10px'
                          }}
                        >
                          {article.url}
                        </a>
                      )}
                      {article.urls && article.urls.map((url, index) => (
                        <a 
                          key={index}
                          href={url} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          style={{ 
                            color: '#3b82f6', 
                            textDecoration: 'none',
                            display: 'block',
                            marginBottom: '10px'
                          }}
                        >
                          {url}
                        </a>
                      ))}
                    </div>
                  )}

                  <div style={{ 
                    borderTop: '1px solid rgba(59, 130, 246, 0.2)',
                    paddingTop: '20px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}>
                    <div>
                      <span style={{ color: '#94a3b8', fontSize: '14px' }}>
                        執筆者: {article.author} | 閲覧数: {article.views.toLocaleString()}回
                      </span>
                    </div>
                    <div style={{ display: 'flex', gap: '10px' }}>
                      {article.tags.map((tag, index) => (
                        <span key={index} style={{ 
                          background: 'rgba(59, 130, 246, 0.2)',
                          color: '#3b82f6',
                          padding: '4px 8px',
                          borderRadius: '12px',
                          fontSize: '12px'
                        }}>
                          #{tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </article>
              </div>

              <div className="col-md-4">
                {/* 関連記事 */}
                <div className="premium-card" style={{ 
                  padding: '30px',
                  background: 'rgba(30, 41, 59, 0.8)',
                  border: '1px solid rgba(59, 130, 246, 0.2)',
                  borderRadius: '12px'
                }}>
                  <h4 style={{ color: '#f1f5f9', marginBottom: '20px' }}>関連記事</h4>
                  {filteredArticles
                    .filter(a => a.id !== article.id && a.category === article.category)
                    .slice(0, 3)
                    .map((relatedArticle) => (
                      <div key={relatedArticle.id} style={{ marginBottom: '20px', cursor: 'pointer' }}
                           onClick={() => window.location.href = `/news/${relatedArticle.id}`}>
                        <div style={{ 
                          padding: '15px',
                          border: '1px solid rgba(59, 130, 246, 0.2)',
                          borderRadius: '8px',
                          transition: 'all 0.2s'
                        }}>
                          <h6 style={{ color: '#f1f5f9', marginBottom: '8px', fontSize: '14px' }}>
                            {relatedArticle.title}
                          </h6>
                          <p style={{ color: '#94a3b8', fontSize: '12px', margin: 0 }}>
                            {relatedArticle.date}
                          </p>
                        </div>
                      </div>
                    ))}
                  
                  <a href="/news" className="btn btn-outline-custom btn-sm" style={{ 
                    width: '100%',
                    color: '#3b82f6',
                    borderColor: '#3b82f6'
                  }}>
                    全ての記事を見る
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    );
  }

  // 記事一覧表示
  return (
    <Layout 
      title="ニュース・IR" 
      subtitle="DeepTeLLの最新情報、技術発表、投資家向け情報をお届けします"
    >
      {/* フィルター */}
      <section style={{ padding: '60px 0 40px', backgroundColor: '#0f172a' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <label style={{ color: '#f1f5f9', marginBottom: '10px', display: 'block' }}>カテゴリで絞り込み</label>
              <select 
                className="form-control"
                value={filterCategory}
                onChange={(e) => setFilterCategory(e.target.value)}
                style={{ 
                  background: 'rgba(30, 41, 59, 0.8)',
                  border: '1px solid #475569',
                  color: '#e2e8f0'
                }}
              >
                {categories.map(category => (
                  <option key={category} value={category}>
                    {category === 'all' ? '全てのカテゴリ' : category}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-6" style={{ display: 'flex', alignItems: 'end' }}>
              <a href="/contact" className="btn btn-custom">
                IRお問い合わせ
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 記事一覧 */}
      <section style={{ padding: '60px 0', backgroundColor: '#1e293b' }}>
        <div className="container">
          <div className="row">
            {filteredArticles.map((article) => (
              <div key={article.id} className="col-md-6" style={{ marginBottom: '40px' }}>
                <article 
                  className="premium-card" 
                  style={{ 
                    padding: '30px',
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid rgba(59, 130, 246, 0.2)',
                    borderRadius: '12px',
                    cursor: 'pointer',
                    transition: 'all 0.3s'
                  }}
                  onClick={() => window.location.href = `/news/${article.id}`}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px' }}>
                    <div style={{ display: 'flex', gap: '8px', flexDirection: 'column', alignItems: 'flex-start' }}>
                      <span style={{ 
                        background: '#1e40af', 
                        color: 'white', 
                        padding: '4px 12px', 
                        borderRadius: '20px',
                        fontSize: '12px'
                      }}>
                        {article.category}
                      </span>
                      <span style={{ color: '#94a3b8', fontSize: '12px' }}>
                        {article.date}
                      </span>
                    </div>
                  </div>

                  <h3 style={{ color: '#f1f5f9', marginBottom: '15px', fontSize: '18px' }}>
                    {article.title}
                  </h3>

                  <p style={{ color: '#94a3b8', marginBottom: '20px', fontSize: '14px' }}>
                    {article.summary}
                  </p>

                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '15px' }}>
                    {article.tags.slice(0, 3).map((tag, index) => (
                      <span key={index} style={{ 
                        background: 'rgba(59, 130, 246, 0.2)',
                        color: '#3b82f6',
                        padding: '2px 8px',
                        borderRadius: '12px',
                        fontSize: '11px'
                      }}>
                        #{tag}
                      </span>
                    ))}
                  </div>

                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center',
                    borderTop: '1px solid rgba(59, 130, 246, 0.2)',
                    paddingTop: '15px'
                  }}>
                    <span style={{ color: '#94a3b8', fontSize: '13px' }}>
                      閲覧数: {article.views.toLocaleString()}回
                    </span>
                    <span style={{ color: '#3b82f6', fontSize: '14px' }}>
                      続きを読む →
                    </span>
                  </div>
                </article>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* IRセクション */}
      <section style={{ padding: '80px 0', backgroundColor: '#0f172a' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div style={{ textAlign: 'center', marginBottom: '50px' }}>
                <h2 style={{ color: '#3b82f6', marginBottom: '15px' }}>投資家情報</h2>
                <p style={{ color: '#cbd5e1' }}>
                  DeepTeLLの財務情報、業績データ、投資家向け資料をご覧いただけます
                </p>
              </div>
            </div>
          </div>
          
          <div className="row">
            <div className="col-md-4">
              <div className="premium-card" style={{ 
                padding: '30px',
                background: 'rgba(30, 41, 59, 0.8)',
                border: '1px solid rgba(59, 130, 246, 0.2)',
                borderRadius: '12px',
                textAlign: 'center'
              }}>
                <h4 style={{ color: '#f1f5f9', marginBottom: '15px' }}>決算情報</h4>
                <p style={{ color: '#94a3b8', marginBottom: '20px' }}>
                  四半期決算、年次決算資料
                </p>
                <button className="btn btn-outline-custom">
                  資料ダウンロード
                </button>
              </div>
            </div>

            <div className="col-md-4">
              <div className="premium-card" style={{ 
                padding: '30px',
                background: 'rgba(30, 41, 59, 0.8)',
                border: '1px solid rgba(59, 130, 246, 0.2)',
                borderRadius: '12px',
                textAlign: 'center'
              }}>
                <h4 style={{ color: '#f1f5f9', marginBottom: '15px' }}>決算説明会</h4>
                <p style={{ color: '#94a3b8', marginBottom: '20px' }}>
                  動画・音声・資料アーカイブ
                </p>
                <button className="btn btn-outline-custom">
                  アーカイブ視聴
                </button>
              </div>
            </div>

            <div className="col-md-4">
              <div className="premium-card" style={{ 
                padding: '30px',
                background: 'rgba(30, 41, 59, 0.8)',
                border: '1px solid rgba(59, 130, 246, 0.2)',
                borderRadius: '12px',
                textAlign: 'center'
              }}>
                <h4 style={{ color: '#f1f5f9', marginBottom: '15px' }}>業績ハイライト</h4>
                <p style={{ color: '#94a3b8', marginBottom: '20px' }}>
                  主要KPI・成長指標
                </p>
                <button className="btn btn-outline-custom">
                  詳細を見る
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA セクション */}
      <section style={{ 
        padding: '80px 0', 
        background: 'linear-gradient(135deg, #1e40af 0%, #1d4ed8 50%, #3b82f6 100%)',
        textAlign: 'center'
      }}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2">
              <h2 style={{ color: 'white', marginBottom: '20px' }}>
                最新情報をいち早くお届け
              </h2>
              <p style={{ color: 'rgba(255, 255, 255, 0.9)', marginBottom: '30px', fontSize: '18px' }}>
                DeepTeLLのニュースレターにご登録いただくと、最新のニュースや技術情報をお届けします。
              </p>
              <a href="/contact" className="btn btn-custom btn-lg" style={{ 
                background: 'rgba(255, 255, 255, 0.2)',
                border: '2px solid white',
                color: 'white'
              }}>
                ニュースレター登録
              </a>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default NewsIRPage; 